/**
 * This pipeline is based on Volcomix's react project.
 * https://github.com/Volcomix/virtual-background
 * It was modified and converted into a module to work with
 * Twilio's Video Processor
 */
import { buildWebGL2Pipeline } from './pipelines/webgl2Pipeline'

export { buildWebGL2Pipeline };
